import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/contabilidad/polizas';
import Contabilidad from './Contabilidad';


const ms2p = (state) => {
  return {
    ...state.poliza,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Contabilidad);
